import React from 'react';
import './ParticipantGroupList.css';
import './RoleSettingList.css';
import ParticipantGroupDot from '../ParticipantGroupDot';
import ActionButton from '../../input/ActionButton';
import { roleLeadSummary } from './groupAdminUtils';

function RoleRow({ setting, selected, onSelect }) {
  return (
    <li className={`groupListRow${selected ? ' isSelected' : ''}`}>
      <button
        type="button"
        className="groupListRowMain"
        onClick={() => onSelect(setting.role)}
        aria-current={selected ? 'true' : undefined}
      >
        <span className="groupListRowDot">
          <ParticipantGroupDot role={setting.role} size="md" withTooltip={false} />
        </span>
        <span className="groupListRowText">
          <span className="groupListRowNameLine">
            <span className="groupListRowName">{setting.name}</span>
          </span>
          <span className="groupListRowMeta">{roleLeadSummary(setting)}</span>
        </span>
      </button>
    </li>
  );
}

/**
 * Section "Rollen" of /groups (below the groups): the fixed roles Orga and Admin with their configured
 * name, dot color and event leadership (RoleSetting). Selecting a row opens the role editor.
 */
function RoleSettingList({ roles, loaded, failed, selectedRole, onSelect, onRetry, retrying, isOffline }) {
  let content;
  if (loaded) {
    content = (
      <ul className="groupListRows">
        {roles.map(setting => (
          <RoleRow key={setting.role} setting={setting} selected={selectedRole === setting.role} onSelect={onSelect} />
        ))}
      </ul>
    );
  } else if (failed) {
    content = (
      <div className="roleListMessage">
        <p>{isOffline ? 'Offline nicht verfügbar.' : 'Die Rollen konnten nicht geladen werden.'}</p>
        {!isOffline && <ActionButton icon="refresh" label="Erneut laden" onClick={onRetry} disabled={retrying} />}
      </div>
    );
  } else {
    content = <p className="roleListMessage">Lädt …</p>;
  }

  return (
    <section className="groupListSection" aria-label="Rollen">
      <h3 className="groupListSectionTitle">Rollen</h3>
      {content}
      <p className="groupListHint">
        Rollen gelten zusätzlich zur Gruppe: Sie geben Zugang zur Verwaltung, färben den Punkt der Person und legen
        Spieltagleitung und Lohn fest.
      </p>
    </section>
  );
}

export default RoleSettingList;
